import 'react-toastify/dist/ReactToastify.css';
import LayoutNotFilter from '../../../data/LayoutNotFilter';
import { useEffect, useState } from 'react';
import Pdv from './pdv';
import PdvForm from './pdv/PdvForm';
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '../../../../redux/store';
import {
  getBrPaymentTypesAsync,
  getBrPaymentTypesProvidersAsync,
  getPaymentMechanismsAsync,
  getPAymentTypePDVAsync,
} from '../../../../redux/features/PaymentTypePDV/services';
import RevenueModal from './revenueModal';
import {
  getChartAccountsync,
  getPAymentTypesync,
} from '../../../../redux/features/paymentType/services';
import { Tab, Tabs } from 'react-bootstrap';
import { PaymentOptions } from './pdv/typeOptionsGroup/obj';

export default function ConsultaFormaRecebimento(props: any) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer?.value);
  const dispatch = useDispatch<AppDispatch>();

  const [keyActived, setKeyActived] = useState('');
  const [key, setKey] = useState<string>(keyActived ? keyActived : props.keyTab);

  const [cadPdv, setCadPdv] = useState<boolean>(false);
  const [editItemPdv, setEditItemPdv] = useState<PaymentOptions | undefined>();

  const handleNewPdv = (e: boolean) => {
    setEditItemPdv(undefined);
    setCadPdv(e);
  };

  const handleEditPdv = (item: PaymentOptions) => {
    setEditItemPdv(item);
    setCadPdv(true);
  };

  useEffect(() => {
    dispatch(getPAymentTypesync(storeMe?.storeActive?.id));
    dispatch(getChartAccountsync(storeMe?.storeActive?.id));
    dispatch(getPAymentTypePDVAsync(storeMe?.storeActive?.id));
    dispatch(getPaymentMechanismsAsync(storeMe?.storeActive?.id));
    dispatch(getBrPaymentTypesAsync(storeMe?.storeActive?.id));
    dispatch(getBrPaymentTypesProvidersAsync(storeMe?.storeActive?.id));
  }, [dispatch]);

  return (
    <LayoutNotFilter
      title={
        props.Title + ` de recebimento` + props.keyTab === 'PDV' ? 'PDV' : ''
      }
    >
      <Tabs
        defaultActiveKey="personData"
        className="mt-2"
        activeKey={key}
        onSelect={(k: any) => setKey(k)}
      >
        {props.keyTab === 'revenue' && (
          <Tab eventKey="revenue" title="Receita ERP" className="mx-3">
            <RevenueModal
              setKeyActived={setKeyActived}
              title={
                props.Title + ` de recebimento` + props.keyTab === 'PDV'
                  ? 'PDV'
                  : ''
              }
            />
          </Tab>
        )}
        {props.keyTab === 'PDV' && (
          <Tab eventKey="PDV" title="Receita PDV" className="mx-3">
            {!cadPdv ? (
              <Pdv
                setKeyActived={setKeyActived}
                onEditItem={handleEditPdv}
                OnAddNewChartAccount={handleNewPdv}
                title={
                  props.Title + ` de recebimento` + props.keyTab === 'PDV'
                    ? 'PDV'
                    : ''
                }
              />
            ) : (
              <PdvForm
                OnAddNewPDV={handleNewPdv}
                listEditeItem={editItemPdv}
                setKeyActived={setKeyActived}
              />
            )}
          </Tab>
        )}
      </Tabs>
    </LayoutNotFilter>
  );
}